(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFaq(root) {
    if (!root || root.dataset.cfaqInit === '1') return;
    root.dataset.cfaqInit = '1';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('.custom-faq__tab'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.custom-faq__panel'));

    function selectTab(id) {
      tabs.forEach(function (t) {
        t.setAttribute('aria-selected', String(t.dataset.cat === id));
      });
      panels.forEach(function (p) {
        p.dataset.active = String(p.dataset.cat === id);
      });
    }

    root.addEventListener('click', function (e) {
      var tab = e.target.closest('.custom-faq__tab');
      if (tab && root.contains(tab)) {
        selectTab(tab.dataset.cat);
        return;
      }
      var trigger = e.target.closest('.custom-faq__trigger');
      if (trigger && root.contains(trigger)) toggle(trigger);
    });

    root.addEventListener('keydown', function (e) {
      var tab = e.target.closest('.custom-faq__tab');
      if (!tab || !root.contains(tab)) return;
      var idx = tabs.indexOf(tab);
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
        e.preventDefault();
        var n = tabs[(idx + 1) % tabs.length];
        n.focus(); selectTab(n.dataset.cat);
      } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
        e.preventDefault();
        var p = tabs[(idx - 1 + tabs.length) % tabs.length];
        p.focus(); selectTab(p.dataset.cat);
      }
    });

    function toggle(trigger) {
      var open = trigger.getAttribute('aria-expanded') === 'true';
      var content = document.getElementById(trigger.getAttribute('aria-controls'));
      trigger.setAttribute('aria-expanded', String(!open));
      if (content) content.dataset.open = String(!open);
    }
  }

  function initAll() {
    document.querySelectorAll('.custom-faq').forEach(initFaq);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.custom-faq');
    if (el) { el.dataset.cfaqInit = ''; initFaq(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-related-products"] && !Shopify.designMode) return;
  try {
    
  var loadRelatedProductsCustom = function () {
    var section = document.querySelector('.related-products-custom');
    if (section === null) return;
    if (!section.dataset.url) {
      // Collection override mode: markup is already rendered server-side, just wire up the carousel.
      initCarousel(section);
      return;
    }
    var request = new XMLHttpRequest();
    request.open('GET', section.dataset.url);
    request.onload = function () {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement('div');
        container.innerHTML = request.response;
        var updated = container.querySelector('.related-products-custom');
        if (updated) section.innerHTML = updated.innerHTML;
        initCarousel(section);
      }
    };
    request.send();
  };

  function initCarousel(root) {
    var wrap = root.querySelector('[data-tt-carousel]');
    if (!wrap) return;
    var track = wrap.querySelector('[data-tt-track]');
    var prev = wrap.querySelector('[data-tt-prev]');
    var next = wrap.querySelector('[data-tt-next]');
    if (!track) return;

    function isScrollable() {
      return track.scrollWidth > track.clientWidth + 2;
    }
    function step() {
      var first = track.firstElementChild;
      if (!first) return 300;
      var gap = parseFloat(window.getComputedStyle(track).columnGap || 0);
      return first.getBoundingClientRect().width + gap;
    }
    function update() {
      if (!prev || !next) return;
      if (!isScrollable()) {
        prev.classList.add('is-hidden');
        next.classList.add('is-hidden');
        return;
      }
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.classList.toggle('is-hidden', track.scrollLeft <= 0);
      next.classList.toggle('is-hidden', track.scrollLeft >= max);
    }
    if (prev)
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    if (next)
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products-custom');
    if (section) loadRelatedProductsCustom();
  });

  loadRelatedProductsCustom();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();
        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function() {

// Look for an element with class 'related-products'
    var productRecommendationsSection = document.querySelector(".related-products");
    if (productRecommendationsSection === null) {
      return;
    }

// Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open("GET", productRecommendationsSection.dataset.url);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
      }
    };
    request.send();
  };

// fetch when section reloads in editor
  document.addEventListener("shopify:section:load", function(event) {
    if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
      loadProductRecommendationsIntoSection();
    }
  });

// Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
